function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  filter: "url(#blob-2_svg__filter0_d)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  clipPath: "url(#blob-2_svg__clip0)"
}, React.createElement("path", {
  opacity: 0.2,
  d: "M263.088 149.103c12.325 25.438 57.823 31.988 56.709 60.251-1.076 27.292-38.221 36.767-61.123 51.754-17.86 11.688-36.977 18.166-57.003 25.549-25.884 9.542-53.804 38.545-77.114 23.895-24.119-15.158-3.887-55.813-15.222-81.925-10.01-23.063-45.808-32.712-45.457-57.866.346-24.783 25.847-42.427 47.037-55.386 18.043-11.035 41.166-3.201 60.956-10.658 28.001-10.552 50.316-54.464 77.176-41.394 26.726 13.005 1.095 59.058 14.041 85.78z",
  fill: "#7C94A1"
}), React.createElement("path", {
  d: "M269.494 166.163c6.599 27.485 49.644 43.613 42.511 70.984-6.887 26.431-45.2 27.743-70.777 37.486-19.946 7.597-40.006 9.837-61.148 12.767-27.326 3.786-60.803 26.146-80.44 6.851-20.32-19.966 8.139-55.353 2.651-83.286-4.847-24.67-37.753-41.751-32.03-66.249 5.637-24.135 34.322-35.917 57.793-44.045 19.985-6.92 40.898 5.677 61.825 2.625 29.61-4.32 60.8-42.444 84.243-23.932 23.326 18.42-11.561 57.927-4.628 86.799z",
  fill: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("clipPath", {
  id: "blob-2_svg__clip0"
}, React.createElement("path", {
  d: "M0 0h375v375H0V0z",
  fill: "#fff"
})), React.createElement("filter", {
  id: "blob-2_svg__filter0_d",
  x: 7,
  y: 38,
  width: 360.883,
  height: 346.48,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: 24
}), React.createElement("feGaussianBlur", {
  stdDeviation: 16
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0.729412 0 0 0 0 0.764706 0 0 0 0.1 0"
}), React.createElement("feBlend", {
  mode: "multiply",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

function SvgBlob2(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 375 375",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgBlob2;